<template>
  <ResendExpiredLink :translations @click="handleResendLink" />
</template>

<script lang="ts" setup>
import ResendExpiredLink from '~/scopes/guest/components/ResendExpiredLink/ResendExpiredLink.vue'
import { useGuestBmUserId } from '~/scopes/guest/composables/useGuestBmUserId'
import translations from '~/scopes/guest/pages/guest-orders-resend-link/GuestOrdersResendLink.translations'

const { bmUserId } = useGuestBmUserId()

function handleResendLink() {
  // eslint-disable-next-line no-alert
  alert(
    `API call is not implemented yet (bm_user_id: ${bmUserId.value ?? 'N/A'})`,
  )
}
</script>
